<template>
    <activation-brief-provider
        v-slot="{
            brief,
            contact,
            productDetails,
            affiliateLinks,
            discountCodes,
            briefFields,
            isLoading,
            steps,
            currentStep,
            isPreview,
            errorMessage,
            completeBrief,
            restartBrief,
        }">
        <activation-brief-overview-view
            :brief="brief"
            :contact="contact"
            :productDetails="productDetails"
            :affiliate-links="affiliateLinks"
            :discount-codes="discountCodes"
            :brief-fields="briefFields"
            :is-preview="isPreview"
            :steps="steps"
            :current-step="currentStep"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :restart-brief="restartBrief"
            @complete-brief="completeBrief"
        />
    </activation-brief-provider>
</template>

<script>
    import ActivationBriefProvider from '../providers/ActivationBriefProvider';
    import ActivationBriefOverviewView from '../data-views/activation-briefs/ActivationBriefOverviewView';

    export default {
        name:       'ActivationBriefOverviewRouterView',
        components: {
            ActivationBriefOverviewView,
            ActivationBriefProvider,
        },
    };
</script>
